export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-list-thumbnails-81d01a1dc2bf3a1925053085566136c4.svg";